// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3-Bsr","head":"ProcedureTableInfo_head__b1Sme"};